import { motion } from "framer-motion";
import { MessageCircle, PenTool, Eye, PartyPopper } from "lucide-react";

const STEPS = [
  {
    icon: MessageCircle,
    title: "Ceritakan Momenmu",
    desc: "Sapa kami lewat WhatsApp. Ceritakan momen, kebutuhan, dan tenggatnya — santai, seperti ngobrol dengan kawan.",
  },
  {
    icon: PenTool,
    title: "Kami Rancang & Bangun",
    desc: "Ceritamu kami terjemahkan menjadi desain dan website yang hidup, lengkap dengan alamat URL pilihanmu. Kamu bebas memilih berbagai template yang tersedia atau custom sendiri keinginanmu.",
  },
  {
    icon: Eye,
    title: "Review & Sempurnakan",
    desc: "Kamu menerima tautan preview dan bisa revisi sampai terasa pas — perayaan tak boleh setengah hati.",
  },
  {
    icon: PartyPopper,
    title: "Rayakan & Sebarkan",
    desc: "Website live. Bagikan tautannya, dan biarkan momenmu dirayakan oleh semua orang yang kamu sayangi.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="cara-kerja"
      data-testid="how-it-works-section"
      className="relative bg-[#0B132B] py-24 lg:py-36"
    >
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 50% 40% at 50% 0%, rgba(201,162,39,0.07), transparent 70%)",
        }}
      />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <p className="font-mono text-[11px] tracking-[0.4em] text-[#C9A227]">
            03 — CARA KERJA
          </p>
          <h2 className="font-display mt-4 text-4xl text-[#F6F0E6] md:text-5xl">
            Dari cerita ke <em className="text-[#E8C98A]">perayaan</em>, empat
            langkah
          </h2>
        </motion.div>
        <div className="relative mt-16 grid gap-10 md:grid-cols-4 md:gap-6">
          <div
            aria-hidden
            className="absolute left-0 right-0 top-8 hidden border-t border-dashed border-[#C9A227]/25 md:block"
          />
          {STEPS.map((step, i) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.14 }}
              className="relative"
              data-testid={`step-${i + 1}`}
            >
              <div className="relative z-10 mb-6 flex h-16 w-16 items-center justify-center rounded-2xl border border-[#C9A227]/40 bg-[#0B132B] text-[#E8C98A]">
                <step.icon size={22} />
              </div>
              <p
                className="font-display text-5xl text-transparent"
                style={{ WebkitTextStroke: "1px rgba(201,162,39,0.55)" }}
              >
                0{i + 1}
              </p>
              <h3 className="font-display mt-3 text-xl text-[#F6F0E6]">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-[#F6F0E6]/60">
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
